import { FC, useCallback } from 'react'
import Image from 'next/image'

import IMG_BG from '../assets/img/process_bg.png'
import IMG_BG_TABLET from '../assets/img/process_bg_tablet.png'
import IMG_BG_MOBILE from '../assets/img/process_bg_mobile.png'

import { Trans } from 'react-i18next'
import { listProcessFixture } from '../fixture/process.fixture'
import Row from '../../../../components/base/Grid/Row'
import Col from '../../../../components/base/Grid/Col'
import { useTranslation } from '../../../../hooks/useTranslation'
import useMixpanel from '../../../../hooks/useMixpanel'

const ProcessHH: FC<{ contactRef?; setIsLazyLoading?; getRef?; getRefMobile? }> = ({ setIsLazyLoading, getRef, getRefMobile }) => {
  const { translate } = useTranslation()
  const Mixpanel = useMixpanel()

  const handleScrollToSection = useCallback(() => {
    // console.log(contactRef.current)
    setIsLazyLoading(false)
    return Promise.all([
      getRef()?.then((targetRef) => {
        targetRef?.current?.scrollIntoView()
      }),

      getRefMobile()?.then((targetRef) => {
        targetRef?.current?.scrollIntoView()
      })
    ]).then(() => {
      return
    })
  }, [])

  return (
    <div className="process">
      <div className="wrapper-container">
        <div className="process-content">
          <h2 className="heading">
            <Trans i18nKey="page_employer_headhunt_service:process_heading">
              <span className="high-light" />
            </Trans>
          </h2>
          <div className="process-description">{translate('page_employer_headhunt_service:process_description')}</div>
          <div className="text-center">
            <a
              id="button_book_a_consultation_1"
              data-mixpanel-event={Mixpanel.EVENTS.CLICK_BOOK_A_CONSULTANT}
              className="btn-book-consultation"
              onClick={() => handleScrollToSection()}>
              {translate('page_employer_headhunt_service:lp_book_a_consultation')}
            </a>
          </div>
        </div>
        <div className="row-wrapper">
          <div className="row-wrapper-bg d-desktop">
            <Image src={IMG_BG} alt={`bg`} height={919} width={1312} />
          </div>
          <div className="row-wrapper-bg d-tablet">
            <Image src={IMG_BG_TABLET} alt={`bg`} height={919} width={1312} />
          </div>
          <div className="row-wrapper-bg d-mobile">
            <Image src={IMG_BG_MOBILE} alt={`bg`} height={1151} width={482} />
          </div>
          <Row className="process-row">
            {listProcessFixture.map((item, index) => (
              <Col xs={24} md={12} lg={6} key={index}>
                <div className={`card card-${item.id}`}>
                  <div className="card-image">
                    <Image src={item.icon} alt={`icon-${item.id}`} height={70} width={70} />
                  </div>
                  <div className="card-content">
                    <div className="card-step">{translate(`page_employer_headhunt_service:${item.number}`)}</div>
                    <h3 className="card-title">{translate(`page_employer_headhunt_service:${item.title}`)}</h3>
                    <div className="card-des">{translate(`page_employer_headhunt_service:${item.des}`)}</div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </div>
      </div>
    </div>
  )
}

export default ProcessHH
